import React from 'react'
import { useDispatch } from 'react-redux'
import Actions from '../../../actions'
import PageCard from '../../common/PageCard'
import Page from '../../common/Page'
import useQuery from '../../../hooks/useQuery'
import { Spin } from 'antd'

import './IframeView.css'
import $t from '../../../i18n'

const IframeView = () => {
  const dispatch = useDispatch()
  const query = useQuery()
  const link = query.get('link')
  const memberName = query.get('memberName')

  const handleBack = () => {
    dispatch(Actions.createAction(Actions.NAVIGATED_BACK))
  }

  return (
    <PageCard
      className="iframe-view"
      headerComponent={
        <div className="member-name-container">
          <i className="icon-arrow-bold-left back-btn" onClick={handleBack} />
          <div className="member-name-button">
            {$t('homeScreen.familyManage')}{' '}
            <span className="member-name">{memberName}</span>
          </div>
        </div>
      }
    >
      <div className="iframe-view-content">
        {link ? (
          <iframe
            title={'iframe-content'}
            src={link}
            width="100%"
            style={{ border: 'none' }}
          />
        ) : (
          <div className="link-iframe-loading">
            <Spin size="large" />
          </div>
        )}
      </div>
    </PageCard>
  )
}

export default IframeView
